import { key } from 'piqure';
import type { DiagnoseDiagnostic } from '@/diagnostic/domain/DiagnoseDiagnostic.ts';
import type { Diagnostics } from '@/diagnostic/domain/Diagnostics.ts';
import type { RulesRepository } from '@/diagnostic/domain/RulesRepository.ts';

export const DIAGNOSE_DIAGNOSTIC = key<DiagnoseDiagnostic>('DiagnoseDiagnostic');
export const DIAGNOSTICS = key<Diagnostics>('Diagnostics');
export const RULES_REPOSITORY = key<RulesRepository>('RulesRepository');
